(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TestScheduleResumeController',TestScheduleResumeController);

    TestScheduleResumeController.$inject = ['$uibModalInstance', 'entity', 'TestSchedule'];

    function TestScheduleResumeController($uibModalInstance, entity, TestSchedule) {
        var vm = this;

        vm.testSchedule = entity;
        vm.clear = clear;
        vm.confirmResume = confirmResume;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmResume (id) {
            TestSchedule.manage(vm.testSchedule, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();
